import { Navigate } from "react-router-dom";

const STORAGE_KEY = "logbook_auth_user_v2";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
